/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ total: NonNullable<unknown> }} Ticketpageoftotal3Inputs */

const en_ticketpageoftotal3 = /** @type {(inputs: Ticketpageoftotal3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`of ${i?.total}`)
};

const de_ticketpageoftotal3 = /** @type {(inputs: Ticketpageoftotal3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`von ${i?.total}`)
};

/**
* | output |
* | --- |
* | "of {total}" |
*
* @param {Ticketpageoftotal3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpageoftotal3 = /** @type {((inputs: Ticketpageoftotal3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpageoftotal3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpageoftotal3(inputs)
	return de_ticketpageoftotal3(inputs)
});
export { ticketpageoftotal3 as "ticketPageOfTotal" }